import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "vivemoto",
  home_url: "/seleccionar_moto",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 40,
  comision: 2,
  textos_tofu: {
    pm: {
      registro_datos_personales: {
        titulo: "Datos personales",
        sub_titulo: "",
      },
    },
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
  firma: {
    provider: "mifiel",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_LH6spFVoC",
      userPoolClientId: "4hasusavvi7cbg067relp3shem",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_WVoXs1tFt",
      userPoolClientId: "788mhqpk5ar7i10bls22eilm9",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
